export const MAP_SET_REGION = 'MAP_SET_REGION'
export const MAP_SET_LOCATION = 'MAP_SET_LOCATION'
export const MAP_SET_CURRENT_LOCATION = 'MAP_SET_CURRENT_LOCATION'
export const MAP_SET_DESTINATION = 'MAP_SET_DESTINATION'
export const MAP_CLEAR_DESTINATION = 'MAP_CLEAR_DESTINATION'
export const MAP_ENABLE_AUTO_JUSTIFYING = 'MAP_ENABLE_AUTO_JUSTIFYING'
export const MAP_DISABLE_AUTO_JUSTIFYING = 'MAP_DISABLE_AUTO_JUSTIFYING'

export const setRegion = (region) => ({
  type: MAP_SET_REGION,
  payload: { region },
})

export const setLocation = (location, isFine) => ({
  type: MAP_SET_LOCATION,
  payload: { location, type: isFine ? 'fine' : 'coarse' },
})

export const setDestination = (location) => ({
  type: MAP_SET_DESTINATION,
  payload: { location },
})

export const clearDestination = () => ({
  type: MAP_CLEAR_DESTINATION,
})

export const enableAutoJustifying = () => ({
  type: MAP_ENABLE_AUTO_JUSTIFYING,
})

export const disableAutoJustifying = () => ({
  type: MAP_DISABLE_AUTO_JUSTIFYING,
})



// WEBPACK FOOTER //
// ./src/common/map/actions.js